<crm-auto-complete
  #innAutoComplete
  [(value)]="selectedPerson"
  (valueChange)="selectedPersonChange.emit($event)"
  [styleClass]="styleClass"
  [class]="class"
  [disabled]="disabled"
  [inputStyle]="inputStyle"
  [suggestions]="persons"
  [isError]="isError"
  [isWithStringValue]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="60"
  [inputStyleClass]="inputStyleClass"
  [appendTo]="appendTo"
  [autofocus]="autofocus"
  optionLabel="inn"
  optionValue="id"
  [placeholder]="placeholder"
  (completeMethod)="personSearch.emit($event.query)">
  <ng-template
    #itemTemplate
    let-person="item">
    <div *ngIf="toPerson(person) as person">
      <div>
        <span [innerHTML]="highlightMatchText(person.name) | safeHtml"></span>
      </div>
      <div class="frm-color-green">
        <span [innerHTML]="highlightMatchText(person.inn) | safeHtml"></span>
      </div>
    </div>
  </ng-template>
</crm-auto-complete>
